/**
 * Session-scoped count of writes the user has been told "saved" but the
 * server hasn't acked yet (settleWrite's optimistic-resolve path).
 * Drives the small cloud badge in the Layout header so operators in
 * dead zones can see work is still syncing.
 *
 * In-memory only: a reload resets the count even though Firestore's own
 * offline mutation queue persists and will still sync. That makes this
 * an indicator, not an exact queue length — good enough to answer "did
 * everything I just did make it up?" before walking out of the
 * rickhouse.
 */
import { create } from 'zustand';

interface PendingWritesState {
  pending: number;
}

export const usePendingWritesStore = create<PendingWritesState>(() => ({
  pending: 0,
}));

export const markWritePending = (): void =>
  usePendingWritesStore.setState((s) => ({ pending: s.pending + 1 }));

export const clearWritePending = (): void =>
  usePendingWritesStore.setState((s) => ({ pending: Math.max(0, s.pending - 1) }));
